import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LocalStorageService {

    set(key: string, value: any) {
        if (value === undefined || value === null) return;
        localStorage.setItem(key, JSON.stringify(value));
    }

    get(key: string) {
        const el = localStorage.getItem(key);
        if (!el || el === 'undefined' || el === 'null') return null;
        try {
            return JSON.parse(el);
        } catch {
            return null;
        }
    }

    remove(key: string) {
        localStorage.removeItem(key);
    }

    clear() {
        localStorage.clear();
    }
}
